export default Object.freeze({
    PRODUCT: 'P',
    CUSTOMER: 'C',
});
